import { Box, BoxProps, CheckBox, ColorOptions, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { useLazyApiData } from '../../../../pg/src/data/store'
import { useStores } from '../../data/store'
import { RootStore, checkIfProfileAccessPresent } from '../../data/store/Root'
import { MessageTypes } from '../../utils'

export const getProfileNamesChannelId = () => {
  const { REACT_APP_PCI_MERCHANT_PROFILE_ID, REACT_APP_NON_PCI_MERCHANT_PROFILE_ID, REACT_APP_EMI_PROFILE_ID } =
    window?._env_
  return [
    { id: '8008', name: 'PCI_MERCHANT', appProfileId: REACT_APP_PCI_MERCHANT_PROFILE_ID },
    { id: '8008', name: 'NON_PCI_MERCHANT', appProfileId: REACT_APP_NON_PCI_MERCHANT_PROFILE_ID },
    { id: '394575653479', name: 'EMI', appProfileId: REACT_APP_EMI_PROFILE_ID },
    // { id: '394575653479', name: 'EMI_NON_PCI' },
    // { id: '394575653479', name: 'EMI_PCI Merchant' },
  ]
}

export const getOthersProducerChannelIds = () => {
  const { REACT_APP_API_CONFIG_MTS_CHANNEL_ID, REACT_APP_API_CONFIG_DMM_CHANNEL_ID } = window?._env_
  return [REACT_APP_API_CONFIG_MTS_CHANNEL_ID, REACT_APP_API_CONFIG_DMM_CHANNEL_ID]
}

export const CheckBoxItem = ({
  item,
  isAllSelected,
  onItemChange,
  hasAccess,
  isEdit,
  isOnboarding,
  headerLabel,
}: any) => {
  const onItemCheckChange = (isChecked: string) => {
    onItemChange(item.apiId, isChecked === 'true')
  }

  return (
    <Box width={'100%'} padding={8}>
      <CheckBox
        textColor={isEdit ? 'BLACK' : 'BLACK_21'}
        disabled={!isEdit || (headerLabel !== 'Others' ? hasAccess || isAllSelected : false)}
        textStyle={'h4Bold'}
        fontSize={14}
        fontWeight={'BOLD'}
        textLabel={item?.apiEndPoint ?? ''}
        checked={item?.isSelected || isAllSelected}
        onChange={onItemCheckChange}
        color={isEdit ? 'PRIMARY' : 'DARK_GREY'}
      />
    </Box>
  )
}

export const CheckBoxGroupItem = ({
  onGroupCheckChange,
  headerLabel,
  listItems,
  isAllSelected,
  onItemCheckChange,
  hasAccess,
  isEdit,
  isOnboarding,
  isApiConfig,
}: any) => {
  console.log('===> CheckBoxGroupItem ', headerLabel, isAllSelected, hasAccess)

  //TODO: causing issues in other selections
  const checkIfAllNotSelected = (arr: any[]) => {
    return arr.filter((data) => data.isSelected).length === 0
  }

  return (
    <Box
      direction="row"
      alignItems={'center'}
      borderTopLeftRadius={isApiConfig ? 8 : undefined}
      borderBottomLeftRadius={isApiConfig ? 8 : undefined}>
      <Box
        backgroundColor={'BACKGROUND_LIGHT'}
        w={220}
        h={isApiConfig ? '100%' : 73}
        padding={isApiConfig ? 16 : 23}
        borderTopLeftRadius={isApiConfig ? undefined : 8}
        borderBottomLeftRadius={isApiConfig ? undefined : 8}
        alignItems={!isApiConfig ? 'center' : 'flex-start'}
        justify={!isApiConfig ? 'center' : 'flex-start'}>
        <ModBox show={!isApiConfig}>
          <CheckBox
            textColor={isEdit ? 'BLACK_21' : 'BLACK_75'}
            disabled={!isEdit} //|| !checkIfAllNotSelected(listItems)
            fontWeight={'BOLD'}
            textLabel={headerLabel}
            textStyle={'h5'}
            onChange={onGroupCheckChange}
            fontSize={14}
            checked={isAllSelected}
            color={isEdit ? 'PRIMARY' : 'DARK_GREY'}
          />
        </ModBox>
        <ModBox show={isApiConfig}>
          <Text
            fontWeight={'BOLD'}
            type={'h5'}
            title={headerLabel}
            color={isEdit ? 'BLACK_21' : 'BLACK_75'}
            fontSize={14}
          />
        </ModBox>
      </Box>
      <Box
        direction="row"
        justifyContent={!isApiConfig ? 'flex-start' : 'space-between'}
        alignItems={!isApiConfig ? 'flex-start' : 'center'}
        w={!isApiConfig ? 250 : 700}
        padding={isApiConfig ? 0 : 32}
        borderRadius={isApiConfig ? 8 : undefined}
        flexWrap={!isApiConfig ? undefined : 'wrap'}>
        {listItems &&
          listItems.map((item: any, index: number) => {
            return (
              <CheckBoxItem
                key={index}
                hasAccess={hasAccess}
                item={item}
                isAllSelected={isAllSelected}
                onItemChange={onItemCheckChange}
                isEdit={isEdit}
                isOnboarding={isOnboarding}
                headerLabel={headerLabel}
              />
            )
          })}
      </Box>
    </Box>
  )
}

interface Props {
  accessData: string[]
  type: string
  isOnboarding: boolean
  channelId: string
  parentEditMode?: boolean
}

export const ApiConfig = ({ accessData, type, isOnboarding, channelId, parentEditMode }: Props) => {
  const {
    getApisList,
    updateSelectedApiIds,
    updateGroupApisStatusByChannelID,
    getCommonInPciNonPci,
    fetchApiConfig,
    getOthersApisList,
    updateGeneralConfigs,
    fetchOthersApiConfig,
    fetchApiMappingListOfChannelId,
    getIndividualApiAccessList,
    isAllPciSelected,
    isAllCommonPciNonPciSelected,
    isAllEmisSelected,
    isAllOthersSelected,
    getOwnChannelId,
    profilesaccesslist,
    accessConfig,
    isApiConfigSaveCallDone,
    resetApiConfigSaveCallDone,
  } = useStores((root) => ({
    getApisList: root.getApisList,
    updateSelectedApiIds: root.updateSelectedApiIds,
    updateGroupApisStatusByChannelID: root.updateGroupApisStatusByChannelID,
    apiListLength: root.apis.length,
    getCommonInPciNonPci: root.getCommonInPciNonPci,
    fetchApiConfig: root.fetchApiConfig,
    getOthersApisList: root.getOthersApisList,
    updateGeneralConfigs: root.onboarding.updateGeneralConfigs,
    fetchOthersApiConfig: root.fetchOthersApiConfig,
    fetchApiMappingListOfChannelId: root.fetchApiMappingListOfChannelId,
    getIndividualApiAccessList: root.getIndividualApiAccessList,
    isAllPciSelected: root.onboarding.isAllPciSelected,
    isAllCommonPciNonPciSelected: root.onboarding.isAllCommonPciNonPciSelected,
    isAllEmisSelected: root.onboarding.isAllEmisSelected,
    isAllOthersSelected: root.onboarding.isAllOthersSelected,
    getOwnChannelId: root.onboarding.getOwnChannelId,
    profilesaccesslist: root?.onboarding.profilesaccesslist,
    accessConfig: root.user.getAccessConfig(['entity_management_service', 'ems_config']),
    isApiConfigSaveCallDone: root.isApiConfigSaveCallDone,
    resetApiConfigSaveCallDone: root.resetApiConfigSaveCallDone,
  }))

  console.log(
    '===> accessData isAllPciSelected isAllCommonPciNonPciSelected isAllEmisSelected isAllOthersSelected',
    JSON.stringify(accessData),
    isAllPciSelected,
    isAllCommonPciNonPciSelected,
    isAllEmisSelected,
    isAllOthersSelected,
  )

  // const [isEdit, setEditMode] = useState(false)
  const [pciList, setPciList] = useState([])
  const [commonPciList, setCommonPciList] = useState([])
  const [emiList, setEmiList] = useState([])
  const [othersList, setOthersList] = useState([])

  const [fetchApiAccessMapping, fetchApiAccessMappingHander] = useLazyApiData(fetchApiMappingListOfChannelId)

  const [fetchPciApiConfigs, fetchPciApiConfigHandler] = useLazyApiData(fetchApiConfig)
  const [fetchNonPciApiConfigs, fetchNonPciApiConfigHandler] = useLazyApiData(fetchApiConfig)
  const [fetchEmiApiConfigs, fetchEmiApiConfigHandler] = useLazyApiData(fetchApiConfig)
  const [fetchOthersApiConfigs, fetchOthersApiConfigHandler] = useLazyApiData(fetchOthersApiConfig)

  useEffect(() => {
    if (fetchApiAccessMappingHander.state === 'fulfilled') {
      getIndividualApiAccessList()
      if (fetchPciApiConfigHandler.state === 'fulfilled') {
        setPciList(getApisList('PCI_MERCHANT'))
      }
      if (fetchNonPciApiConfigHandler.state === 'fulfilled') {
        setCommonPciList(getCommonInPciNonPci())
      }
      if (fetchEmiApiConfigHandler.state === 'fulfilled') {
        setEmiList(getApisList('EMI'))
      }
      if (fetchOthersApiConfigHandler.state === 'fulfilled') {
        setOthersList(getOthersApisList())
      }
    }
  }, [
    fetchApiAccessMappingHander.state,
    fetchEmiApiConfigHandler.state,
    fetchNonPciApiConfigHandler.state,
    fetchOthersApiConfigHandler.state,
    fetchPciApiConfigHandler.state,
    getApisList,
    getCommonInPciNonPci,
    getIndividualApiAccessList,
    getOthersApisList,
  ])

  useEffect(() => {
    if (accessData && accessData.length > 0) {
      if (accessData.includes('PCI_MERCHANT') && accessData.includes('NON_PCI_MERCHANT')) {
        updateGeneralConfigs('isAllCommonPciNonPciSelected', true)
      }
      if (accessData.includes('PCI_MERCHANT')) {
        updateGeneralConfigs('isAllPciSelected', true)
      }
      //TODO: Check for other EMI conditions
      if (accessData.includes('EMI')) {
        updateGeneralConfigs('isAllEmisSelected', true)
      }
      if (accessData.includes('NON_PCI_MERCHANT')) {
        updateGeneralConfigs('isAllCommonPciNonPciSelected', true)
      }
    }
  }, [accessData, updateGeneralConfigs])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callApisPostUpdate = () => {
    const profiles = getProfileNamesChannelId()
    if (profiles.length > 0) {
      profiles.map((profile) => {
        setTimeout(() => {
          console.log('fetchApiConfigs: ', profile.name)
          if (profile.name === 'PCI_MERCHANT') {
            fetchPciApiConfigs(profile.id, profile.name)
          } else if (profile.name === 'NON_PCI_MERCHANT') {
            fetchNonPciApiConfigs(profile.id, profile.name)
          } else if (profile.name === 'EMI') {
            fetchEmiApiConfigs(profile.id, profile.name)
          }
        }, 100)
      })
    }
    const ownChannelId = getOwnChannelId()
    fetchApiAccessMapping(ownChannelId, 'ACCESS_LIST')
    fetchOthersApiConfigs('OTHERS')
  }

  useEffect(() => {
    if (isApiConfigSaveCallDone) {
      // callApisPostUpdate()
      resetApiConfigSaveCallDone()
    }
  }, [callApisPostUpdate, isApiConfigSaveCallDone, resetApiConfigSaveCallDone])

  useEffect(() => {
    const profiles = getProfileNamesChannelId()
    if (profiles.length > 0) {
      profiles.map((profile) => {
        setTimeout(() => {
          console.log('fetchApiConfigs: ', profile.name)
          if (profile.name === 'PCI_MERCHANT') {
            fetchPciApiConfigs(profile.id, profile.name)
          } else if (profile.name === 'NON_PCI_MERCHANT') {
            fetchNonPciApiConfigs(profile.id, profile.name)
          } else if (profile.name === 'EMI') {
            fetchEmiApiConfigs(profile.id, profile.name)
          }
        }, 100)
      })
    }
    //TODO: get channel ids for below
    //This call is to get list of apis which has access to this channel id
    //which wil be used to check if individual apis have access in api config
    // EMS testing app 329339775323
    const ownChannelId = getOwnChannelId()
    fetchApiAccessMapping(ownChannelId, 'ACCESS_LIST')
  }, [fetchApiAccessMapping, fetchEmiApiConfigs, fetchNonPciApiConfigs, fetchPciApiConfigs, getOwnChannelId])

  useEffect(() => {
    //This calls is for Others category of apiconfig
    // const othersProducerChannelIds = getOthersProducerChannelIds()
    // if (othersProducerChannelIds.length > 0) {
    //   othersProducerChannelIds.map((producerChannelId) => {
    //     console.log('===> fetchOthersApiConfigs producerChannelId', producerChannelId)
    fetchOthersApiConfigs('OTHERS')
    // })
    // }
  }, [fetchOthersApiConfigs])

  const onAllPCIPress = () => {
    updateGeneralConfigs('isAllPciSelected', !isAllPciSelected)
    updateGroupApisStatusByChannelID('PCI_MERCHANT', !isAllPciSelected)
    setPciList(getApisList('PCI_MERCHANT'))

    updateGeneralConfigs('isAllCommonPciNonPciSelected', !isAllCommonPciNonPciSelected)
    updateGroupApisStatusByChannelID('NON_PCI_MERCHANT', !isAllCommonPciNonPciSelected)
    setCommonPciList(getCommonInPciNonPci())
  }
  const onAllNonPCIPress = () => {
    updateGroupApisStatusByChannelID('NON_PCI_MERCHANT', !isAllCommonPciNonPciSelected)
    updateGeneralConfigs('isAllCommonPciNonPciSelected', !isAllCommonPciNonPciSelected)
    setCommonPciList(getCommonInPciNonPci())
  }

  const onAllEmiPress = () => {
    updateGroupApisStatusByChannelID('EMI', !isAllEmisSelected)
    updateGeneralConfigs('isAllEmisSelected', !isAllEmisSelected)
    setEmiList(getApisList('EMI'))
  }

  const onAllOthersPress = () => {
    updateGroupApisStatusByChannelID('OTHERS', !isAllOthersSelected)
    updateGeneralConfigs('isAllOthersSelected', !isAllOthersSelected)
    setOthersList(getOthersApisList())
  }
  const onPCIGroupCheckChange = (isChecked: string) => {
    updateGroupApisStatusByChannelID('PCI_MERCHANT', isChecked === 'true')
    updateGeneralConfigs('isAllPciSelected', isChecked === 'true')
    setPciList(getApisList('PCI_MERCHANT'))
  }

  const onNonPCIGroupCheckChange = (isChecked: string) => {
    updateGroupApisStatusByChannelID('NON_PCI_MERCHANT', isChecked === 'true')
    updateGeneralConfigs('isAllCommonPciNonPciSelected', isChecked === 'true')
    setCommonPciList(getCommonInPciNonPci())
  }

  const onEmiGroupCheckChange = (isChecked: string) => {
    updateGroupApisStatusByChannelID('EMI', isChecked === 'true')
    updateGeneralConfigs('isAllEmisSelected', isChecked === 'true')
    setEmiList(getApisList('EMI'))
  }

  const onOthersGroupCheckChange = (isChecked: string) => {
    updateGroupApisStatusByChannelID('OTHERS', isChecked === 'true')
    updateGeneralConfigs('isAllOthersSelected', isChecked === 'true')
    setOthersList(getOthersApisList())
  }

  const checkIfAlreadySelected = (id: string, list: any[]) => {
    if (list.filter((api) => api.id === id && api.isSelected).length > 0) {
      return true
    } else {
      return false
    }
  }

  const onPciItemCheckChange = (id: string, status: boolean) => {
    if (!checkIfAlreadySelected(id, commonPciList)) {
      if (status === false) {
        onPCIGroupCheckChange('false')
      }
      updateSelectedApiIds('PCI_MERCHANT', id, status)
      setPciList(getApisList('PCI_MERCHANT'))
    } else {
      RootStore.message.setMessage('Already selected in Common PCI NON pci', MessageTypes.INFO)
    }
  }

  const onNonPciItemCheckChange = (id: string, status: boolean) => {
    if (!checkIfAlreadySelected(id, pciList)) {
      if (status === false) {
        onNonPCIGroupCheckChange('false')
      }
      updateSelectedApiIds('NON_PCI_MERCHANT', id, status)
      setCommonPciList(getCommonInPciNonPci())
    } else {
      RootStore.message.setMessage('Already selected in PCI', MessageTypes.INFO)
    }
  }

  const onEmiItemCheckChange = (id: string, status: boolean) => {
    if (status === false) {
      onEmiGroupCheckChange('false')
    }
    updateSelectedApiIds('EMI', id, status)
    setEmiList(getApisList('EMI'))
  }

  const onOthersItemCheckChange = (id: string, status: boolean) => {
    if (status === false) {
      onOthersGroupCheckChange('false')
    }
    updateSelectedApiIds('OTHERS', id, status)
    setOthersList(getOthersApisList())
  }

  return (
    <>
      <ModBox
        show={
          fetchApiAccessMappingHander.state === 'pending' ||
          fetchEmiApiConfigHandler.state === 'pending' ||
          fetchOthersApiConfigHandler.state === 'pending' ||
          fetchPciApiConfigHandler.state === 'pending' ||
          fetchNonPciApiConfigHandler.state === 'pending'
        }>
        <Loader type={'large'} color="PRIMARY" />
      </ModBox>
      <ModBox
        show={
          fetchApiAccessMappingHander.state !== 'pending' &&
          fetchEmiApiConfigHandler.state !== 'pending' &&
          fetchOthersApiConfigHandler.state !== 'pending' &&
          fetchPciApiConfigHandler.state !== 'pending' &&
          fetchNonPciApiConfigHandler.state !== 'pending'
        }
        f={1}
        overflow={'auto'}
        pv={32}
        ph={16}>
        <Box direction="row" justifyContent={'space-between'}>
          <ModBox show={true}>
            <Text title={'API Configuration'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
            <Spacer size={18} direction={'vertical'} />
            <ModBox show={false} backgroundColor={'#FBF6EC' as ColorOptions} borderRadius={2} padding={4}>
              <Text
                title={'Below information is fetched from Parent(). You may edit the information.'}
                color={'#A97425' as ColorOptions}
                fontSize={12}
                fontFamily={'jiotype-medium'}
              />
            </ModBox>
          </ModBox>
        </Box>
        <Box {...styles.parentContainer}>
          <Box direction="row" marginHorizontal={32} marginVertical={8} paddingVertical={8}>
            <Box
              borderColor={'BORDER_COLOR'}
              borderWidth={1}
              borderRadius={16}
              onPress={onAllPCIPress}
              disabled={!parentEditMode}
              alignItems={'center'}
              justifyContent={'center'}
              height={32}
              width={70}
              underlayColor={'PRIMARY_LIGHT_GREY'}
              backgroundColor={isAllPciSelected ? ('#0070B614' as ColorOptions) : 'WHITE'}>
              <Text title={'ALL PCI'} color={'PRIMARY'} />
            </Box>
            <Spacer size={16} direction="horizontal" />
            <Box
              borderColor={'BORDER_COLOR'}
              borderWidth={1}
              borderRadius={16}
              onPress={onAllNonPCIPress}
              disabled={!parentEditMode}
              alignItems={'center'}
              justifyContent={'center'}
              height={32}
              width={220}
              underlayColor={'PRIMARY_LIGHT_GREY'}
              backgroundColor={isAllCommonPciNonPciSelected ? ('#0070B614' as ColorOptions) : 'WHITE'}>
              <Text title={'ALL Common in PCI & Non-PCI'} color={'PRIMARY'} />
            </Box>
            <Spacer size={16} direction="horizontal" />
            <Box
              borderColor={'BORDER_COLOR'}
              borderWidth={1}
              borderRadius={16}
              onPress={onAllEmiPress}
              disabled={!parentEditMode}
              alignItems={'center'}
              justifyContent={'center'}
              height={32}
              width={70}
              underlayColor={'PRIMARY_LIGHT_GREY'}
              backgroundColor={isAllEmisSelected ? ('#0070B614' as ColorOptions) : 'WHITE'}>
              <Text title={'ALL EMI'} color={'PRIMARY'} />
            </Box>
            <Spacer size={16} direction="horizontal" />
            <Box
              borderColor={'BORDER_COLOR'}
              borderWidth={1}
              borderRadius={16}
              onPress={onAllOthersPress}
              disabled={!parentEditMode}
              alignItems={'center'}
              justifyContent={'center'}
              height={32}
              width={100}
              underlayColor={'PRIMARY_LIGHT_GREY'}
              backgroundColor={isAllOthersSelected ? ('#0070B614' as ColorOptions) : 'WHITE'}>
              <Text title={'ALL Others'} color={'PRIMARY'} />
            </Box>
          </Box>
          <Box>
            <Box w={'100%'} h={1} backgroundColor={'BORDER_COLOR'} />
            <CheckBoxGroupItem
              onGroupCheckChange={onPCIGroupCheckChange}
              headerLabel={'Only PCI'}
              listItems={pciList}
              isAllSelected={isAllPciSelected}
              onItemCheckChange={onPciItemCheckChange}
              hasAccess={checkIfProfileAccessPresent('PCI_MERCHANT', profilesaccesslist)}
              isEdit={parentEditMode}
              isOnboarding={isOnboarding}
              isApiConfig={true}
            />
            <Box w={'100%'} h={1} backgroundColor={'BORDER_COLOR'} />
            <CheckBoxGroupItem
              onGroupCheckChange={onNonPCIGroupCheckChange}
              headerLabel={'Common in PCI & Non-PCI'}
              listItems={commonPciList}
              isAllSelected={isAllCommonPciNonPciSelected || isAllPciSelected}
              onItemCheckChange={onNonPciItemCheckChange}
              hasAccess={checkIfProfileAccessPresent('NON_PCI_MERCHANT', profilesaccesslist)}
              isEdit={parentEditMode}
              isOnboarding={isOnboarding}
              isApiConfig={true}
            />
          </Box>
        </Box>
        <Box {...styles.parentContainer}>
          <ModBox>
            <CheckBoxGroupItem
              onGroupCheckChange={onEmiGroupCheckChange}
              headerLabel={'EMI APIs'}
              listItems={emiList}
              isAllSelected={isAllEmisSelected}
              onItemCheckChange={onEmiItemCheckChange}
              hasAccess={checkIfProfileAccessPresent('EMI', profilesaccesslist)}
              isEdit={parentEditMode}
              isOnboarding={isOnboarding}
              isApiConfig={true}
            />
          </ModBox>
          <Box w={'100%'} h={1} backgroundColor={'BORDER_COLOR'} />
          <ModBox>
            <CheckBoxGroupItem
              onGroupCheckChange={onOthersGroupCheckChange}
              headerLabel={'Others'}
              listItems={othersList}
              isAllSelected={isAllOthersSelected}
              onItemCheckChange={onOthersItemCheckChange}
              hasAccess={false}
              isEdit={parentEditMode}
              isOnboarding={isOnboarding}
              isApiConfig={true}
            />
          </ModBox>
        </Box>
      </ModBox>
    </>
  )
}

const styles = {
  parentContainer: {
    borderWidth: 1,
    borderRadius: 4,
    borderColor: 'BORDER_COLOR',
    minWidth: '100%',
    marginTop: 32,
  } as BoxProps,
}
